"use strict";

// =====================================================
// COMISIONES
//
// Archivo:
// src/fronend/Ingresos/comisiones/comisiones.js
//
// =====================================================


// =====================================================
// VARIABLES
// =====================================================

let registroscomisiones = [];

let moduloComisionesInicializado = false;

let tbodyComisiones = null;

let buscarComisiones = null;

let btnLimpiarBusqueda = null;


// =====================================================
// LISTAR COMISIONES
// =====================================================

async function listarComisiones() {

    try {

        console.log(
            "🔄 Cargando comisiones..."
        );


        const respuesta = await fetch(
            "/comisiones/listar"
        );


        if (!respuesta.ok) {

            throw new Error(
                `HTTP ${respuesta.status}`
            );

        }


        const resultado =
            await respuesta.json();


        console.log(
            "📦 Respuesta /comisiones/listar:",
            resultado
        );


        if (!resultado.ok) {

            console.error(
                "❌ Error al listar comisiones:",
                resultado.mensaje
            );


            registroscomisiones = [];

            actualizarResumen();

            renderizarTablaComisiones();

            return;

        }


        registroscomisiones =
            Array.isArray(resultado.data)
                ? resultado.data
                : [];


        console.log(
            "✅ Registros de comisiones:",
            registroscomisiones
        );


        actualizarResumen();

        renderizarTablaComisiones();


    } catch (error) {

        console.error(
            "❌ Error al consultar /comisiones/listar:",
            error
        );


        registroscomisiones = [];

        actualizarResumen();

        renderizarTablaComisiones();

    }

}


// =====================================================
// RENDERIZAR TABLA
// =====================================================

function renderizarTablaComisiones() {


    if (!tbodyComisiones) {

        tbodyComisiones =
            document.getElementById(
                "tbodyComisiones"
            );

    }


    if (!tbodyComisiones) {

        console.error(
            "❌ No existe #tbodyComisiones"
        );

        return;

    }


    tbodyComisiones.innerHTML = "";


    if (
        !Array.isArray(registroscomisiones) ||
        registroscomisiones.length === 0
    ) {

        tbodyComisiones.innerHTML = `

            <tr>

                <td
                    colspan="26"
                    class="text-center py-5 text-muted">

                    <i
                        class="bi bi-inbox fs-1 d-block mb-2">
                    </i>

                    No hay registros de comisiones

                </td>

            </tr>

        `;

        return;

    }


    registroscomisiones.forEach(
        (registro, indice) => {

            const fila =
                document.createElement("tr");


            const idIngreso =
                registro.IDINGRESONO ?? "";


            const fechaIngreso =
                formatearFecha(
                    registro.FECHAINGRESO
                );


            const idEmpleado =
                registro.IDEMPLEADO ?? "";


            const nombreEmpleado =
                registro.NOMBREEMPLEADO ?? "";


            const dpi =
                registro.DPI ?? "";


            const nombrePuesto =
                registro.NOMBREPUESTO ?? "";


            const direccion =
                registro.DIRECCION ?? "";


            const salarioBase =
                registro.SALARIOBASE ?? 0;


            const diasLaborales =
                obtenerValor(
                    registro,
                    "CANTIDADLABORALES",
                    "DIAS LABORALES",
                    "DIASLABORALES"
                );


            const horasEstablecidas =
                registro.HORASESTABLECIDAS ?? 0;


            const horasExtras =
                registro.HORASEXTRAS ?? 0;


            const pagoOrdinario =
                registro.PAGOORDINARIAHREXTRA ?? 0;


            const pagoExtra =
                registro.PAGOEXTRA ?? 0;


            const totalHorasExtras =
                registro.TOTALEXTRAPAGADO ?? 0;


            const horasDobles =
                registro.HRSDOBLES ?? 0;


            const pagoHoraDoble =
                registro.PAGOHRSDOBLE ?? 0;


            const totalHorasDobles =
                registro.TOTALHRSDOBLES ?? 0;


            const totalExtrasDobles =
                registro.TOTALEXTRASYDOBLES ?? 0;


            const bonificacionDecreto =
                registro.BONIFICACIONDECRETO ?? 0;


            const totalBonificacion =
                registro.PAGOTOTALPORBONIFICACION ?? 0;


            const bonificacionProduccion =
                registro.BONIFICACIONPORPRODUCCION ?? 0;


            const totalProduccion =
                registro.TOTALAPAGARPORPRODUCCIONBONIFICACION ?? 0;


            const comisiones =
                registro.COMISIONES ?? 0;


            const totalComisiones =
                registro.TOTALAPAGARPORCOMISIONES ?? 0;


            const estado =
                registro.ESTADO ?? "";


            fila.innerHTML = `

                <td class="text-center">
                    ${indice + 1}
                </td>

                <td class="text-center">
                    ${escapeHTML(idIngreso)}
                </td>

                <td class="text-center">
                    ${escapeHTML(fechaIngreso)}
                </td>

                <td>

                    <div class="d-flex align-items-center">

                        <span class="employee-avatar">

                            ${obtenerIniciales(
                                nombreEmpleado
                            )}

                        </span>

                        <span class="employee-name">

                            ${escapeHTML(
                                nombreEmpleado
                            )}

                        </span>

                    </div>

                </td>

                <td class="text-center">

                    ${escapeHTML(dpi)}

                </td>

                <td>

                    ${escapeHTML(nombrePuesto)}

                </td>

                <td>

                    ${escapeHTML(direccion)}

                </td>

                <td class="text-end salary">

                    Q
                    ${formatearMoneda(
                        salarioBase
                    )}

                </td>

                <td class="text-end">

                    ${formatearNumero(
                        diasLaborales
                    )}

                </td>

                <td class="text-end">

                    ${formatearNumero(
                        horasEstablecidas
                    )}

                </td>

                <td class="text-end">

                    ${formatearNumero(
                        horasExtras
                    )}

                </td>

                <td class="text-end money">

                    Q
                    ${formatearMoneda(
                        pagoOrdinario
                    )}

                </td>

                <td class="text-end money">

                    Q
                    ${formatearMoneda(
                        pagoExtra
                    )}

                </td>

                <td class="text-end money-total">

                    Q
                    ${formatearMoneda(
                        totalHorasExtras
                    )}

                </td>

                <td class="text-end">

                    ${formatearNumero(
                        horasDobles
                    )}

                </td>

                <td class="text-end money">

                    Q
                    ${formatearMoneda(
                        pagoHoraDoble
                    )}

                </td>

                <td class="text-end money-total">

                    Q
                    ${formatearMoneda(
                        totalHorasDobles
                    )}

                </td>

                <td class="text-end money-total">

                    Q
                    ${formatearMoneda(
                        totalExtrasDobles
                    )}

                </td>

                <td class="text-end money">

                    Q
                    ${formatearMoneda(
                        bonificacionDecreto
                    )}

                </td>

                <td class="text-end money-total">

                    Q
                    ${formatearMoneda(
                        totalBonificacion
                    )}

                </td>

                <td class="text-end money">

                    Q
                    ${formatearMoneda(
                        bonificacionProduccion
                    )}

                </td>

                <td class="text-end money-total">

                    Q
                    ${formatearMoneda(
                        totalProduccion
                    )}

                </td>

                <td class="text-end">

                    <span class="comision">

                        Q
                        ${formatearMoneda(
                            comisiones
                        )}

                    </span>

                </td>

                <td class="text-end money-total">

                    Q
                    ${formatearMoneda(
                        totalComisiones
                    )}

                </td>

                <td class="text-center">

                    ${
                        String(estado)
                            .trim()
                            .toUpperCase() === "A"

                            ? `

                                <span class="badge-activo">

                                    Activo

                                </span>

                              `

                            : `

                                <span class="badge-inactivo">

                                    Inactivo

                                </span>

                              `
                    }

                </td>

                <td class="text-center">

                    <button
                        type="button"
                        class="btn btn-sm btn-outline-primary btnEditarComision"
                        data-id-ingreso="${escapeHTML(idIngreso)}"
                        title="Editar comisión">

                 <i class="bi bi-cash-stack"></i>

                    </button>

                </td>

            `;


            tbodyComisiones.appendChild(
                fila
            );

        }
    );


    const botonesEditar =
        tbodyComisiones.querySelectorAll(
            ".btnEditarComision"
        );


    botonesEditar.forEach(
        boton => {

            boton.addEventListener(
                "click",
                function () {

                    const idIngreso =
                        this.dataset.idIngreso;


                    console.log(
                        "🖱️ Click en editar:",
                        idIngreso
                    );


                    editarComision(
                        idIngreso
                    );

                }
            );

        }
    );

}


// =====================================================
// ACTUALIZAR RESUMEN
// =====================================================

function actualizarResumen() {


    const totalEmpleados =
        document.getElementById(
            "totalEmpleados"
        );


    const totalSalarios =
        document.getElementById(
            "totalSalarios"
        );


    const totalComisiones =
        document.getElementById(
            "totalComisiones"
        );


    const totalPagoComisiones =
        document.getElementById(
            "totalPagoComisiones"
        );


    let cantidadEmpleados = 0;

    let sumaSalarios = 0;

    let sumaComisiones = 0;

    let sumaTotalComisiones = 0;


    if (
        Array.isArray(
            registroscomisiones
        )
    ) {

        cantidadEmpleados =
            registroscomisiones.length;


        registroscomisiones.forEach(
            registro => {

                sumaSalarios +=
                    numeroSeguro(
                        registro.SALARIOBASE
                    );


                sumaComisiones +=
                    numeroSeguro(
                        registro.COMISIONES
                    );


                sumaTotalComisiones +=
                    numeroSeguro(
                        registro.TOTALAPAGARPORCOMISIONES
                    );

            }
        );

    }


    if (totalEmpleados) {

        totalEmpleados.textContent =
            cantidadEmpleados;

    }


    if (totalSalarios) {

        totalSalarios.textContent =
            `Q ${formatearMoneda(
                sumaSalarios
            )}`;

    }


    if (totalComisiones) {

        totalComisiones.textContent =
            `Q ${formatearMoneda(
                sumaComisiones
            )}`;

    }


    if (totalPagoComisiones) {

        totalPagoComisiones.textContent =
            `Q ${formatearMoneda(
                sumaTotalComisiones
            )}`;

    }

}


// =====================================================
// OBTENER VALOR
// =====================================================

function obtenerValor(
    registro,
    ...nombres
) {


    if (!registro) {

        return 0;

    }


    for (
        const nombre
        of nombres
    ) {

        if (
            Object.prototype.hasOwnProperty.call(
                registro,
                nombre
            )
        ) {

            const valor =
                registro[nombre];


            if (
                valor !== null &&
                valor !== undefined &&
                valor !== ""
            ) {

                return valor;

            }

        }

    }


    return 0;

}


// =====================================================
// CONVERTIR NÚMERO
// =====================================================

function numeroSeguro(valor) {


    if (
        valor === null ||
        valor === undefined ||
        valor === ""
    ) {

        return 0;

    }


    if (
        typeof valor === "number"
    ) {

        return isNaN(valor)
            ? 0
            : valor;

    }


    const texto =
        String(valor)
            .replace(/,/g, "")
            .trim();


    const numero =
        Number(texto);


    return isNaN(numero)
        ? 0
        : numero;

}


// =====================================================
// FORMATEAR MONEDA
// =====================================================

function formatearMoneda(
    valor
) {

    const numero =
        numeroSeguro(valor);


    return numero.toLocaleString(
        "es-GT",
        {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }
    );

}


// =====================================================
// FORMATEAR NÚMERO
// =====================================================

function formatearNumero(
    valor
) {

    const numero =
        numeroSeguro(valor);


    return numero.toLocaleString(
        "es-GT",
        {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }
    );

}


// =====================================================
// FORMATEAR FECHA
// =====================================================

function formatearFecha(
    valor
) {

    if (!valor) {

        return "";

    }


    try {

        const fecha =
            new Date(valor);


        if (
            isNaN(
                fecha.getTime()
            )
        ) {

            return String(valor);

        }


        const dia =
            String(
                fecha.getUTCDate()
            )
            .padStart(
                2,
                "0"
            );


        const mes =
            String(
                fecha.getUTCMonth() + 1
            )
            .padStart(
                2,
                "0"
            );


        const anio =
            fecha.getUTCFullYear();


        return `${dia}/${mes}/${anio}`;


    } catch (error) {

        return String(valor);

    }

}


// =====================================================
// OBTENER INICIALES
// =====================================================

function obtenerIniciales(
    nombre
) {


    if (!nombre) {

        return "E";

    }


    const partes =
        String(nombre)
            .trim()
            .split(/\s+/)
            .filter(Boolean);


    if (
        partes.length === 1
    ) {

        return partes[0]
            .substring(
                0,
                2
            )
            .toUpperCase();

    }


    return (
        partes[0][0] +
        partes[1][0]
    ).toUpperCase();

}


// =====================================================
// ESCAPAR HTML
// =====================================================

function escapeHTML(
    valor
) {


    if (
        valor === null ||
        valor === undefined
    ) {

        return "";

    }


    return String(valor)
        .replace(
            /&/g,
            "&amp;"
        )
        .replace(
            /</g,
            "&lt;"
        )
        .replace(
            />/g,
            "&gt;"
        )
        .replace(
            /"/g,
            "&quot;"
        )
        .replace(
            /'/g,
            "&#039;"
        );

}


// =====================================================
// FECHA PARA INPUT DATE
// =====================================================

function obtenerFechaInput(
    valor
) {


    if (!valor) {

        return "";

    }


    const fecha =
        new Date(valor);


    if (
        isNaN(
            fecha.getTime()
        )
    ) {

        return "";

    }


    const anio =
        fecha.getUTCFullYear();


    const mes =
        String(
            fecha.getUTCMonth() + 1
        )
        .padStart(
            2,
            "0"
        );


    const dia =
        String(
            fecha.getUTCDate()
        )
        .padStart(
            2,
            "0"
        );


    return `${anio}-${mes}-${dia}`;

}


// =====================================================
// ASIGNAR VALOR
// =====================================================

function asignarValor(
    id,
    valor
) {


    const elemento =
        document.getElementById(
            id
        );


    if (!elemento) {

        console.warn(
            `⚠️ No existe #${id}`
        );

        return;

    }


    elemento.value =
        valor ?? "";

}


// =====================================================
// ASIGNAR TEXTO MONEDA
// =====================================================

function asignarTextoMoneda(
    id,
    valor
) {


    const elemento =
        document.getElementById(
            id
        );


    if (!elemento) {

        console.warn(
            `⚠️ No existe #${id}`
        );

        return;

    }


    elemento.textContent =
        `Q ${formatearMoneda(
            valor
        )}`;

}


// =====================================================
// OBTENER NÚMERO DESDE LABEL
// =====================================================

function obtenerNumeroDesdeElemento(
    id
) {


    const elemento =
        document.getElementById(
            id
        );


    if (!elemento) {

        console.warn(
            `⚠️ No existe #${id}`
        );

        return 0;

    }


    const texto =
        elemento.textContent
            .replace(
                /Q/g,
                ""
            )
            .replace(
                /,/g,
                ""
            )
            .trim();


    return numeroSeguro(
        texto
    );

}


// =====================================================
// CALCULAR TOTAL A PAGAR POR COMISIONES
// =====================================================

function calcularTotalComisiones() {


    const inputComisiones =
        document.getElementById(
            "comisiones"
        );


    const inputTotalComisiones =
        document.getElementById(
            "totalApagarPorComisiones"
        );


    if (
        !inputComisiones ||
        !inputTotalComisiones
    ) {

        console.warn(
            "⚠️ No se encontraron los inputs de comisiones"
        );

        return;

    }


    const comision =
        numeroSeguro(
            inputComisiones.value
        );


    const baseComision =
        obtenerNumeroDesdeElemento(
            "totalExtrasBonificacion"
        );


    const total =
        baseComision *
        (
            comision /
            100
        );


    console.log(
        "💰 Base para comisión:",
        baseComision
    );


    console.log(
        "📊 Comisión:",
        comision
    );


    console.log(
        "💵 Total comisión:",
        total
    );


    inputTotalComisiones.value =
        total.toFixed(2);

}


// =====================================================
// ACTUALIZAR COMISIÓN
//
// PUT /comisiones/actualizar
//
// Ejecuta:
//
// SP_INGRESONOMINA_COMISIONES
//
// =====================================================

async function actualizarComision() {

    try {

        // =================================================
        // BOTÓN
        // =================================================

        const botonGuardar =
            document.getElementById(
                "btnGuardarComision"
            );


        if (!botonGuardar) {

            console.error(
                "❌ No existe #btnGuardarComision"
            );

            return;

        }


        // =================================================
        // OBTENER ID
        // =================================================

        const idIngreso =
            botonGuardar.dataset.idIngreso;


        if (
            !idIngreso ||
            Number(idIngreso) <= 0
        ) {

            alert(
                "No se encontró el ID del ingreso."
            );

            return;

        }


        // =================================================
        // OBTENER COMISIONES
        // =================================================

        const inputComisiones =
            document.getElementById(
                "comisiones"
            );


        const comisiones =
            numeroSeguro(
                inputComisiones
                    ? inputComisiones.value
                    : 0
            );


        // =================================================
        // CALCULAR TOTAL
        // =================================================

        calcularTotalComisiones();


        const inputTotalComisiones =
            document.getElementById(
                "totalApagarPorComisiones"
            );


        const totalApagarComisiones =
            numeroSeguro(
                inputTotalComisiones
                    ? inputTotalComisiones.value
                    : 0
            );


        // =================================================
        // ESTADO
        // =================================================

        const inputEstado =
            document.getElementById(
                "estadoComision"
            );


        const estado =
            inputEstado &&
            inputEstado.value
                ? inputEstado.value
                : "A";


        // =================================================
        // MOSTRAR DATOS
        // =================================================

        console.log(
            "======================================"
        );


        console.log(
            "💾 ACTUALIZANDO COMISIÓN"
        );


        console.log(
            "IDINGRESONO:",
            idIngreso
        );


        console.log(
            "COMISIONES:",
            comisiones
        );


        console.log(
            "TOTALAPAGARCOMISIONES:",
            totalApagarComisiones
        );


        console.log(
            "ESTADO:",
            estado
        );


        console.log(
            "======================================"
        );


        // =================================================
        // ENVIAR AL BACKEND
        // =================================================

        const respuesta =
            await fetch(
                "/comisiones/actualizar",
                {

                    method: "PUT",

                    headers: {

                        "Content-Type":
                            "application/json"

                    },

                    body:
                        JSON.stringify({

                            IDINGRESONO:
                                Number(
                                    idIngreso
                                ),

                            COMISIONES:
                                comisiones,

                            TOTALAPAGARCOMISIONES:
                                totalApagarComisiones,

                            ESTADO:
                                estado

                        })

                }
            );


        // =================================================
        // LEER RESPUESTA
        // =================================================

        const resultado =
            await respuesta.json();


        console.log(
            "📦 Respuesta actualizar:",
            resultado
        );


        // =================================================
        // VALIDAR RESPUESTA
        // =================================================

        if (
            !respuesta.ok ||
            !resultado.ok
        ) {

            throw new Error(
                resultado.mensaje ||
                `HTTP ${respuesta.status}`
            );

        }


        // =================================================
        // MENSAJE
        // =================================================

        alert(
            "Comisión actualizada correctamente."
        );


        // =================================================
        // CERRAR MODAL
        // =================================================

        const elementoModal =
            document.getElementById(
                "modalComision"
            );


        if (elementoModal) {

            const modal =
                bootstrap.Modal
                    .getOrCreateInstance(
                        elementoModal
                    );


            modal.hide();

        }


        // =================================================
        // RECARGAR TABLA
        // =================================================

        await listarComisiones();


    } catch (error) {

        console.error(
            "❌ Error al actualizar comisión:",
            error
        );


        alert(
            "Error al actualizar la comisión: " +
            error.message
        );

    }

}


// =====================================================
// EDITAR COMISIÓN
// =====================================================

function editarComision(
    idIngreso
) {


    console.log(
        "======================================"
    );


    console.log(
        "✏️ EDITAR COMISIÓN"
    );


    console.log(
        "ID INGRESO:",
        idIngreso
    );


    console.log(
        "======================================"
    );


    const registro =
        registroscomisiones.find(
            item =>
                String(
                    item.IDINGRESONO
                ) ===
                String(
                    idIngreso
                )
        );


    if (!registro) {

        console.error(
            "❌ NO SE ENCONTRÓ EL REGISTRO"
        );

        return;

    }


    console.log(
        "✅ REGISTRO ENCONTRADO:",
        registro
    );


    // =================================================
    // DATOS DEL EMPLEADO
    // =================================================

    asignarValor(
        "mostrarIdEmpleado",
        registro.IDEMPLEADO ?? ""
    );


    asignarValor(
        "nombreEmpleado",
        registro.NOMBREEMPLEADO
    );


    asignarValor(
        "dpiEmpleado",
        registro.DPI
    );


    asignarValor(
        "puestoEmpleado",
        registro.NOMBREPUESTO
    );


    asignarValor(
        "direccionEmpleado",
        registro.DIRECCION
    );


    // =================================================
    // INFORMACIÓN LABORAL
    // =================================================

    asignarValor(
        "salarioBase",
        formatearMoneda(
            registro.SALARIOBASE
        )
    );


    asignarValor(
        "diasLaborales",
        formatearNumero(
            obtenerValor(
                registro,
                "CANTIDADLABORALES",
                "DIAS LABORALES",
                "DIASLABORALES"
            )
        )
    );


    asignarValor(
        "horasEstablecidas",
        formatearNumero(
            registro.HORASESTABLECIDAS
        )
    );


    asignarValor(
        "fechaIngreso",
        obtenerFechaInput(
            registro.FECHAINGRESO
        )
    );


    asignarValor(
        "estadoComision",
        registro.ESTADO ?? "A"
    );


    // =================================================
    // HORAS EXTRAS
    // =================================================

    asignarValor(
        "horasExtras",
        formatearNumero(
            registro.HORASEXTRAS
        )
    );


    asignarTextoMoneda(
        "pagoOrdinariaHrExtra",
        registro.PAGOORDINARIAHREXTRA
    );


    asignarTextoMoneda(
        "pagoExtra",
        registro.PAGOEXTRA
    );


    asignarTextoMoneda(
        "totalExtraPagado",
        registro.TOTALEXTRAPAGADO
    );


    // =================================================
    // HORAS DOBLES
    // =================================================

    asignarValor(
        "hrsDobles",
        formatearNumero(
            registro.HRSDOBLES
        )
    );


    asignarTextoMoneda(
        "pagoHrsDoble",
        registro.PAGOHRSDOBLE
    );


    asignarTextoMoneda(
        "totalHorasDoblesModal",
        registro.TOTALHRSDOBLES
    );


    const valorTotalExtrasDobles =
        registro.TOTALEXTRASYDOBLES ?? 0;


    asignarTextoMoneda(
        "totalExtrasDobles",
        valorTotalExtrasDobles
    );


    // =================================================
    // BONIFICACIÓN DECRETO
    // =================================================

    asignarValor(
        "bonificacionDecreto",
        numeroSeguro(
            registro.BONIFICACIONDECRETO
        ).toFixed(2)
    );


    asignarValor(
        "pagoTotalPorBonificacion",
        numeroSeguro(
            registro.PAGOTOTALPORBONIFICACION
        ).toFixed(2)
    );


    // =================================================
    // BONIFICACIÓN POR PRODUCCIÓN
    // =================================================

    asignarValor(
        "bonificacionProduccion",
        numeroSeguro(
            registro.BONIFICACIONPORPRODUCCION
        ).toFixed(2)
    );


    asignarValor(
        "totalProduccionBonificacion",
        numeroSeguro(
            registro.TOTALAPAGARPORPRODUCCIONBONIFICACION
        ).toFixed(2)
    );


    // =================================================
    // COMISIONES
    // =================================================

    const valorComision =
        numeroSeguro(
            registro.COMISIONES
        );


    const totalComision =
        numeroSeguro(
            registro.TOTALAPAGARPORCOMISIONES
        );


    asignarValor(
        "comisiones",
        valorComision.toFixed(2)
    );


    asignarValor(
        "totalApagarPorComisiones",
        totalComision.toFixed(2)
    );


    // =================================================
    // RESUMEN
    // =================================================

    const salario =
        numeroSeguro(
            registro.SALARIOBASE
        );


    const extrasDobles =
        numeroSeguro(
            registro.TOTALEXTRASYDOBLES
        );


    asignarTextoMoneda(
        "resumenSalario",
        salario
    );


    asignarTextoMoneda(
        "resumenExtrasDobles",
        extrasDobles
    );


    asignarTextoMoneda(
        "resumenComisiones",
        totalComision
    );


    const totalResumen =
        salario +
        extrasDobles +
        totalComision;


    asignarTextoMoneda(
        "resumenTotal",
        totalResumen
    );


    // =================================================
    // TOTAL EXTRAS + BONIFICACIÓN
    // =================================================

    const totalExtrasBonificacion =
        extrasDobles +
        numeroSeguro(
            registro.PAGOTOTALPORBONIFICACION
        );


    asignarTextoMoneda(
        "totalExtrasBonificacion",
        totalExtrasBonificacion
    );


    // =================================================
    // GUARDAR ID EN BOTÓN
    // =================================================

    const botonGuardar =
        document.getElementById(
            "btnGuardarComision"
        );


    if (botonGuardar) {

        botonGuardar.dataset.idIngreso =
            idIngreso;


        console.log(
            "💾 ID guardado en botón:",
            botonGuardar.dataset.idIngreso
        );

    }


    // =================================================
    // ABRIR MODAL
    // =================================================

    const elementoModal =
        document.getElementById(
            "modalComision"
        );


    if (!elementoModal) {

        console.error(
            "❌ NO EXISTE #modalComision"
        );

        return;

    }


    if (
        typeof bootstrap ===
        "undefined"
    ) {

        console.error(
            "❌ BOOTSTRAP NO ESTÁ CARGADO"
        );

        return;

    }


    try {

        const modal =
            bootstrap.Modal.getOrCreateInstance(
                elementoModal
            );


        modal.show();


        console.log(
            "✅ MODAL ABIERTO"
        );


    } catch (error) {

        console.error(
            "❌ ERROR AL ABRIR MODAL:",
            error
        );

    }

}


// =====================================================
// HACER EDITARCOMISION GLOBAL
// =====================================================

window.editarComision =
    editarComision;


// =====================================================
// INICIALIZAR MÓDULO
// =====================================================

function inicializarComisiones() {


    if (
        moduloComisionesInicializado
    ) {

        return;

    }


    moduloComisionesInicializado =
        true;


    console.log(
        "🚀 Inicializando módulo de comisiones..."
    );


    // =================================================
    // ELEMENTOS
    // =================================================

    tbodyComisiones =
        document.getElementById(
            "tbodyComisiones"
        );


    buscarComisiones =
        document.getElementById(
            "buscarComisiones"
        );


    btnLimpiarBusqueda =
        document.getElementById(
            "btnLimpiarBusqueda"
        );


    // =================================================
    // VALIDAR TABLA
    // =================================================

    if (!tbodyComisiones) {

        console.error(
            "❌ No existe #tbodyComisiones"
        );

        return;

    }


    // =================================================
    // CARGAR DATOS
    // =================================================

    listarComisiones();


    // =================================================
    // BUSCADOR
    // =================================================

    if (
        buscarComisiones
    ) {

        buscarComisiones.addEventListener(
            "input",
            function () {

                const texto =
                    this.value
                        .toLowerCase()
                        .trim();


                if (!texto) {

                    renderizarTablaComisiones();

                    actualizarResumen();

                    return;

                }


                const registrosOriginales =
                    registroscomisiones;


                const registrosFiltrados =
                    registrosOriginales.filter(
                        registro => {

                            return (

                                String(
                                    registro.IDINGRESONO ?? ""
                                )
                                .toLowerCase()
                                .includes(texto)


                                ||


                                String(
                                    registro.IDEMPLEADO ?? ""
                                )
                                .toLowerCase()
                                .includes(texto)


                                ||


                                String(
                                    registro.NOMBREEMPLEADO ?? ""
                                )
                                .toLowerCase()
                                .includes(texto)


                                ||


                                String(
                                    registro.DPI ?? ""
                                )
                                .toLowerCase()
                                .includes(texto)


                                ||


                                String(
                                    registro.NOMBREPUESTO ?? ""
                                )
                                .toLowerCase()
                                .includes(texto)


                                ||


                                String(
                                    registro.DIRECCION ?? ""
                                )
                                .toLowerCase()
                                .includes(texto)


                                ||


                                String(
                                    registro.ESTADO ?? ""
                                )
                                .toLowerCase()
                                .includes(texto)

                            );

                        }
                    );


                registroscomisiones =
                    registrosFiltrados;


                renderizarTablaComisiones();


                registroscomisiones =
                    registrosOriginales;

            }
        );

    }


    // =================================================
    // LIMPIAR BÚSQUEDA
    // =================================================

    if (
        btnLimpiarBusqueda
    ) {

        btnLimpiarBusqueda.addEventListener(
            "click",
            function () {

                if (
                    buscarComisiones
                ) {

                    buscarComisiones.value =
                        "";

                }


                renderizarTablaComisiones();

                actualizarResumen();

            }
        );

    }


    // =================================================
    // INPUT COMISIONES
    //
    // CALCULA AUTOMÁTICAMENTE:
    //
    // TOTALAPAGARPORCOMISIONES
    //
    // =================================================

    const inputComisiones =
        document.getElementById(
            "comisiones"
        );


    if (inputComisiones) {

        inputComisiones.addEventListener(
            "input",
            function () {

                calcularTotalComisiones();

            }
        );


        console.log(
            "✅ Evento de cálculo de comisiones activado"
        );

    } else {

        console.warn(
            "⚠️ No existe #comisiones"
        );

    }


    // =================================================
    // BOTÓN ACTUALIZAR
    //
    // #btnGuardarComision
    //
    // =================================================

    const btnGuardarComision =
        document.getElementById(
            "btnGuardarComision"
        );


    if (btnGuardarComision) {

        btnGuardarComision.addEventListener(
            "click",
            function () {

                actualizarComision();

            }
        );


        console.log(
            "✅ COMISIONES REALIZADAS"
        );

    } else {

        console.warn(
            "⚠️ No existe #btnGuardarComision"
        );

    }

}


// =====================================================
// DOM READY
// =====================================================

document.addEventListener(
    "DOMContentLoaded",
    function () {

        console.log(
            "📄 DOM listo para comisiones"
        );


        inicializarComisiones();

    }
);